import { useScrollAnimation } from '@/hooks/use-scroll-animation'
import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'

const WhyUnique = () => {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <section className="py-16 md:py-20 px-4 bg-gradient-to-br from-muted/40 via-muted/20 to-background">
      <div
        ref={ref}
        className={`container mx-auto max-w-4xl transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center space-y-6">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold leading-tight text-foreground">
            Somos guardiões de{' '}
            <span className="font-serif text-gold italic">memórias</span>
          </h2>
          <div className="space-y-4 text-sm md:text-base text-muted-foreground max-w-2xl mx-auto">
            <p className="leading-relaxed">
              Acreditamos que as melhores memórias são aquelas que podemos tocar
              e reconhecemos o poder de uma história bem contada.
            </p>
            <p className="leading-relaxed">
              Para nós, cada história é única. Nossa missão é entregar mais do
              que um álbum comum; é construir uma narrativa visual com um design
              profissional exclusivo que valorize a sua história.
            </p>
            <p className="leading-relaxed">
              Cada álbum é o resultado de um processo cuidadoso e intencional.
              Cada etapa é pensada para que o resultado final seja tão especial
              quanto os momentos vividos. É um trabalho feito por quem entende a
              importância de cada recordação.
            </p>
            <p className="leading-relaxed">
              Nosso compromisso é com a sua história. Atuamos como guardiões de
              memórias, criando álbuns que vão durar gerações. Feitos para serem
              vistos, tocados e compartilhados, hoje e sempre.
            </p>
            <p className="leading-relaxed font-medium text-foreground">
              Confie suas memórias a quem se importa com elas.
            </p>
          </div>
          <Button
            variant="outline"
            className="gap-2 border-primary text-primary hover:bg-primary/10"
            asChild
          >
            <a href="/proposito">
              Saber mais
              <ArrowRight className="h-4 w-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  )
}

export default WhyUnique
